import { getData, postData, putData, deleteData } from "../apiClient";

// get room types
export const getRoomWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/room/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Room with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get user data with id
export const getRoomDataWithId = async (id) => {
    try {
        const result = await getData(`/room/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Room data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create user 
export const createRoom = async ({ data }) => {
    try {
        const result = await postData(`/room/create-room/`, data);

        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Room add API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete user
export const deleteRoom = async ({ id }) => {
    try {
        const result = await deleteData(`/room/delete-room/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Room API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// update user data
export const updateRoom = async ({ id, data }) => {
    try {
        const result = await putData(`/room/update-room/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Room API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

export const getRoomSizeType = async () => {
    try {
        const result = await getData(`/room/room-size-type`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Room API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}

export const getBedsList = async () => {
    try {
        const result = await getData(`/room/beds-type`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Room API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}
